import React, { useState, useEffect } from 'react';
import './Tjanstevillkor.css';
import { getPrivacyConfig } from '../../services/api';

function Integritetspolicy() {
  const [privacyEmail, setPrivacyEmail] = useState('');

  useEffect(() => {
    getPrivacyConfig().then(config => setPrivacyEmail(config.contact_email)).catch(() => {});
  }, []);

  return (
    <div className="tos-page">
      <div className="tos-container">
        <h1>Integritetspolicy för besökare</h1>
        <p className="tos-updated">Senast uppdaterad: 2026-02-24</p>

        <hr />

        <section>
          <h2>1. Personuppgiftsansvarig</h2>
          <p>
            Personuppgiftsansvarig för behandlingen av dina personuppgifter är det Lantmännen-bolag
            som ansvarar för den anläggning du besöker. Vid frågor om hur dina uppgifter behandlas,
            kontakta:
          </p>
          <p>
            <strong>E-post:</strong> {privacyEmail || 'Se receptionen för kontaktuppgifter'}
          </p>
        </section>

        <hr />

        <section>
          <h2>2. Vilka uppgifter samlas in</h2>
          <p>Vid registrering i besökssystemet samlas följande personuppgifter in:</p>
          <ul>
            <li>Namn</li>
            <li>Företagstillhörighet</li>
            <li>Besöksorsak</li>
            <li>Telefonnummer</li>
            <li>Tidpunkt för in- och utcheckning (registreras automatiskt)</li>
          </ul>
          <p>Inga känsliga personuppgifter (artikel 9 GDPR) behandlas.</p>
        </section>

        <hr />

        <section>
          <h2>3. Ändamål med behandlingen</h2>
          <p>Dina personuppgifter behandlas för följande ändamål:</p>
          <ul>
            <li><strong>Säkerhet och trygghet</strong> — för att veta vilka som befinner sig i lokalen</li>
            <li><strong>Brandskydd och utrymning</strong> — för att kunna upprätta utrymningslistor vid nödsituationer</li>
            <li><strong>Besökshantering och spårbarhet</strong> — för att kunna hantera och följa upp besök vid behov</li>
          </ul>
        </section>

        <hr />

        <section>
          <h2>4. Rättslig grund</h2>
          <p>
            Behandlingen av dina personuppgifter grundas på <strong>berättigat intresse</strong> enligt
            artikel 6.1(f) i dataskyddsförordningen (GDPR).
          </p>
          <p>
            Det berättigade intresset är anläggningens behov av att upprätthålla säkerhet och trygghet
            för alla som vistas i lokalerna, samt att kunna uppfylla krav på brandskydd och utrymningsberedskap.
          </p>
          <p>
            En bedömning har gjorts att detta intresse inte åsidosätter dina grundläggande rättigheter
            och friheter, med hänsyn till att uppgifterna är begränsade, lagringstiden är kort (30 dagar)
            och att ingen profilering eller vidarebefordran till tredje part sker.
          </p>
        </section>

        <hr />

        <section>
          <h2>5. Mottagare av uppgifterna</h2>
          <p>Dina personuppgifter kan komma att delas med följande mottagare:</p>
          <ul>
            <li><strong>Receptionspersonal och ansvariga på anläggningen</strong> — för daglig besökshantering</li>
            <li><strong>Systemleverantör (Tech Management Solutions Sweden AB)</strong> — i egenskap av personuppgiftsbiträde, för drift och underhåll av systemet</li>
            <li><strong>Amazon Web Services (AWS)</strong> — som underbiträde för serverhosting (data lagras inom EU, Stockholm)</li>
          </ul>
          <p>Inga uppgifter säljs eller delas med tredje part för marknadsföringsändamål.</p>
        </section>

        <hr />

        <section>
          <h2>6. Överföring till tredje land</h2>
          <p>
            Alla personuppgifter lagras och behandlas inom EU/EES. Ingen överföring till länder
            utanför EU/EES sker.
          </p>
        </section>

        <hr />

        <section>
          <h2>7. Lagringstid</h2>
          <p>
            Dina personuppgifter lagras i <strong>högst 30 dagar</strong> från din incheckning.
            Därefter raderas de automatiskt och permanent ur systemet.
          </p>
        </section>

        <hr />

        <section>
          <h2>8. Dina rättigheter</h2>
          <p>Enligt GDPR har du följande rättigheter avseende dina personuppgifter:</p>
          <ul>
            <li><strong>Rätt till tillgång</strong> (artikel 15) — du kan begära en kopia av dina uppgifter</li>
            <li><strong>Rätt till rättelse</strong> (artikel 16) — du kan begära att felaktiga uppgifter korrigeras</li>
            <li><strong>Rätt till radering</strong> (artikel 17) — du kan begära att dina uppgifter raderas</li>
            <li><strong>Rätt till begränsning</strong> (artikel 18) — du kan begära att behandlingen begränsas</li>
            <li><strong>Rätt till dataportabilitet</strong> (artikel 20) — du kan begära att få dina uppgifter i maskinläsbart format</li>
            <li><strong>Rätt att invända</strong> (artikel 21) — du har rätt att invända mot behandling som grundas på berättigat intresse</li>
          </ul>
          <p>
            För att utöva dina rättigheter, kontakta: <strong>{privacyEmail || 'Se receptionen för kontaktuppgifter'}</strong>
          </p>
          <p>Vi besvarar din förfrågan inom 30 dagar.</p>
        </section>

        <hr />

        <section>
          <h2>9. Rätt att klaga</h2>
          <p>
            Om du anser att behandlingen av dina personuppgifter strider mot GDPR har du rätt att
            lämna in ett klagomål till tillsynsmyndigheten:
          </p>
          <p>
            <strong>Integritetsskyddsmyndigheten (IMY)</strong><br />
            Box 8114, 104 20 Stockholm<br />
            <strong>Webbplats:</strong> www.imy.se<br />
            <strong>E-post:</strong> imy@imy.se
          </p>
        </section>

        <hr />

        <section>
          <h2>10. Är det obligatoriskt att lämna uppgifterna?</h2>
          <p>
            Att lämna dina personuppgifter är en förutsättning för att få tillgång till anläggningen.
            Det är inte en lagstadgad skyldighet, men utan registrering kan besöket inte genomföras.
          </p>
        </section>

        <hr />

        <section>
          <h2>11. Automatiserat beslutsfattande</h2>
          <p>
            Inget automatiserat beslutsfattande eller profilering sker baserat på dina personuppgifter.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Integritetspolicy;
